import Headline, { type Props } from "./Headline";

export default function H6({size = "sm", ...props}:Props) {
  return <Headline tag="h6" size={size} {...props}/>;
}